<template>
  <div class="select">
    <input readonly type="text" :value="inputValue" :placeholder="placeholder" class="input" @click="visible = true" />
    <Popup v-model="visible" position="bottom">
      <div class="btn">
        <div class="cancel" @click="cancel">取消</div>
        <div class="confirm" @click="confirm">确认</div>
      </div>
      <CheckboxGroup v-model="selectValue">
        <CellGroup>
          <Cell v-for="(item, index) in buildinglist" :key="index" :title="item.name" @click="toggle(index)">
            <template #right-icon>
              <Checkbox :name="item.id" ref="checkboxes" />
            </template>
          </Cell>
        </CellGroup>
      </CheckboxGroup>
    </Popup>
  </div>
</template>

<script>
import { Popup, Checkbox, CheckboxGroup, CellGroup, Cell } from 'vant';
export default {
  props: ['value', 'placeholder', 'buildinglist'],
  components: { Popup, Checkbox, CheckboxGroup, CellGroup, Cell },
  data() {
    return {
      visible: false,
      selectValue: [], // ids，非受控
    };
  },
  watch: {
    // props value 不一定是初始值，用watch"同步"
    value(val) {
      // 过滤掉不存在的值，所见即所得
      const idsInList = (val || []).filter(id => this.buildinglist.some(item => item.id === id));
      this.selectValue = idsInList;
    },
  },
  computed: {
    inputValue() {
      return (
        this.buildinglist
          .filter(item => (this.value || []).includes(item.id))
          .map(item => item.name)
          .join('、') || ''
      );
    },
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    cancel() {
      this.visible = false;
      // 同时把选中的值恢复
      this.selectValue = this.value;
    },
    confirm() {
      this.$emit('update:value', this.selectValue);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  /deep/ .van-cell-group {
    min-height: 20vh;
    max-height: 50vh;
    overflow: auto;
  }

  /deep/ .van-cell__title {
    text-align: left;
  }
}
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: calc(100% - 80px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    color: #949aa4;
  }
}
.btn {
  display: flex;
  justify-content: space-between;
}
.cancel,
.confirm {
  padding: 20px;
  color: #00ccbf;
  font-size: 30px;
}
</style>
